import * as angular from 'angular';
import 'angular-smart-table';
import {SerfWebCore} from '../core/core.module';
import './gesuch.module.scss';
import {BankkontoViewComponentConfig} from './component/bankkontoView/bankkontoView';
import {GesuchErstellenViewComponentConfig} from './component/gesuchErstellenView/gesuchErstellenView';
import {gesuchRun} from './gesuch.route';
import {DVFremdkostenComponentConfig} from './component/dv-fremdkosten/dv-fremdkosten';
import {SchadenfallViewComponentConfig} from './component/schadenfallView/schadenfallView';
import {AufwaendeViewComponentConfig} from './component/aufwaendeView/aufwaendeView';
import {EigenleistungEditViewComponentConfig} from './component/eigenleistungView/eigenleistungView';
import {DVEigenleistungenComponentConfig} from './component/dv-eigenleistungen/dv-eigenleistungen';
import {VorleistungEditViewComponentConfig} from './component/vorleistungView/vorleistungView';
import {DVVorleistungComponentConfig} from './component/dv-vorleistung/dv-vorleistung';
import {SchadenEditViewComponentConfig} from './component/schadenView/schadenView';
import {FremdkostenEditViewComponentConfig} from './component/fremdkostenView/fremdkostenView';
import {BemerkungViewComponentConfig} from './component/bemerkungView/bemerkungView';
import {EntschaedigungViewComponentConfig} from './component/entschaedigungView/entschaedigungView';
import {BeitragEditViewComponentConfig} from './component/beitragView/beitragView';
import {AbschlussViewComponentConfig} from './component/abschlussView/abschlussView';

export const SerfWebGesuch = angular.module('serfWeb.gesuch', [SerfWebCore.name])
    .component('dvGesuchErstellenView', new GesuchErstellenViewComponentConfig())
    .component('dvBemerkungView', new BemerkungViewComponentConfig())
    .component('dvFremdkosten', new DVFremdkostenComponentConfig())
    .component('dvEigenleistungen', new DVEigenleistungenComponentConfig())
    .component('dvSchadenfallView', new SchadenfallViewComponentConfig())
    .component('dvAbschlussView', new AbschlussViewComponentConfig())
    .component('dvAufwaendeView', new AufwaendeViewComponentConfig())
    .component('dvEigenleistungEditView', new EigenleistungEditViewComponentConfig())
    .component('dvSchadenEditView', new SchadenEditViewComponentConfig())
    .component('dvVorleistungEditView', new VorleistungEditViewComponentConfig())
    .component('dvFremdkostenEditView', new FremdkostenEditViewComponentConfig())
    .component('dvVorleistung', new DVVorleistungComponentConfig())
    .component('dvEntschaedigungView', new EntschaedigungViewComponentConfig())
    .component('dvBeitragView', new BeitragEditViewComponentConfig())
    .component('dvBankkontoView', new BankkontoViewComponentConfig())
    .run(gesuchRun);

export default SerfWebGesuch;



// WEBPACK FOOTER //
// ./src/app/gesuch/gesuch.module.ts